import classNames from 'classnames'
import isNull from 'lodash/isNull'
import PropTypes from 'prop-types'

import Checkbox from 'components/Core/Checkbox/Checkbox'
import Image from 'components/Core/Image/Image'
import Swatch from 'components/Core/Swatch/Swatch'

import styles from './DetailedItemList.module.css'

const DetailedItemList = ({ children, className }) => (
  <div className={classNames(styles.Container, className)}>{children}</div>
)

DetailedItemList.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}
DetailedItemList.defaultProps = {
  children: null,
  className: '',
}

const Header = ({ children, className }) => (
  <div className={classNames(styles.Header, className)}>{children}</div>
)

Header.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}
Header.defaultProps = {
  children: null,
  className: '',
}

const Row = ({ children, className }) => (
  <div className={classNames(styles.Row, className)}>{children}</div>
)

Row.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}
Row.defaultProps = {
  children: null,
  className: '',
}

const ParentItem = ({ description, image, title, className }) => (
  <div className={classNames(styles.ParentItemContainer, className)}>
    <Image alt={title} src={image} />
    <div className={styles.ParentItemHeader}>
      <div className={styles.HeaderTitle}>{title}</div>
      <div className={styles.HeaderSubtitle}>{description}</div>
    </div>
  </div>
)

ParentItem.propTypes = {
  description: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
}
ParentItem.defaultProps = {
  description: null,
  image: null,
  title: null,
  className: '',
}

const List = ({ children, className }) => (
  <div className={classNames(styles.List, className)}>{children}</div>
)

List.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}
List.defaultProps = {
  children: null,
  className: '',
}

const Item = ({
  id,
  swatch,
  isSelectable,
  title,
  onClick,
  isSelected,
  className,
}) => {
  const checkBoxProps = {
    small: true,
    checked: isSelected,
  }
  if (onClick) {
    checkBoxProps.onClick = (_, data) => onClick({ id, ...data })
  }
  return (
    <div
      className={classNames(styles.ItemContainer, className, {
        [styles.IsSelectable]: isSelectable,
      })}
    >
      <Swatch
        width={20}
        height={20}
        swatch={swatch}
        small={isNull(swatch)}
        className={styles.Swatch}
      />
      <div className={styles.ItemName}>{title}</div>
      {isSelectable && <Checkbox {...checkBoxProps} />}
    </div>
  )
}
Item.propTypes = {
  id: PropTypes.string.isRequired,
  swatch: PropTypes.object,
  isSelectable: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
  isSelected: PropTypes.bool,
  className: PropTypes.string,
}
Item.defaultProps = {
  swatch: {},
  isSelectable: true,
  title: '',
  onClick: undefined,
  isSelected: undefined,
  className: '',
}

DetailedItemList.Header = Header
DetailedItemList.Row = Row
DetailedItemList.List = List
DetailedItemList.Item = Item
DetailedItemList.ParentItem = ParentItem

export default DetailedItemList
